import React, { useEffect, useState } from 'react'

import { Grid, Header, Row } from '@plurall/elo-beta'
import LoadingContainer from 'App/components/LoadingContainer/LoadingContainer'
import MainMenu from 'App/components/MainMenu/MainMenu'
import { PERSONAL_DATA } from 'graphql/queries'

import { graphqlClient, handleGraphQLErrorsWithToast, redirectToHome } from 'utils'

import CardAccessData from './CardAccessData'
import CardPersonalData from './CardPersonalData'

const PersonalData = () => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  const getPersonalData = async () => {
    try {
      const { data } = await graphqlClient().query({
        query: PERSONAL_DATA,
      })

      setData(data)
    } catch (e) {
      handleGraphQLErrorsWithToast(
        e,
        'Não foi possível carregar os dados. Tente novamente mais tarde.',
      )

      setError(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPersonalData()
  }, [])

  if (loading) {
    return <LoadingContainer text='Carregando informações...' fullscreen />
  }

  if (error) {
    redirectToHome()
    return null
  }

  return (
    <>
      <Header description='Gerencie suas informações de cadastro no Plurall'>
        Dados pessoais e acesso
      </Header>
      <Grid desktop={12}>
        <Row>
          <MainMenu />
          <Grid desktop={9}>
            <CardPersonalData data={data?.person} />
            <CardAccessData data={data?.person} />
          </Grid>
        </Row>
      </Grid>
    </>
  )
}

export default PersonalData
